<template>
  <div class="driver-container">
    <div>
      <header class="relative">
        <van-image :src="$oss(4)" alt srcset></van-image>
        <div class="header-info flex flex-y align-center">
          <div class="header-info-title text-26 text-bold">加入顺风车</div>
          <div class="text-grey margin-top-4">安全出行的好选择</div>
        </div>
      </header>
      <div class="bg-white join-us padding-tb-20 padding-lr-14">
        <div class="driver-title-tip">两大理由加入我们</div>
        <div class="join-us-content margin-top-20">
          <div class="flex-1 padding-14 relative" v-for="item in joinList" :key="item.id">
            <div class="text-bold">{{ item.name }}</div>
            <div class="text-12 text-grey margin-top-2">{{ item.name }}</div>
            <van-image class="icon" width="40" :src="$oss(item.icon)"></van-image>
          </div>
        </div>
      </div>

      <div class="bg-white padding-tb-20 padding-lr-14 margin-top-8">
        <div class="driver-title-tip">为了顺利完成认证请准备好</div>
        <div class="text-12 text-grey1 margin-top-4">请确保车辆在你身边，认证需拍摄车辆</div>
        <div class="margin-top-20 card-content">
          <div v-for="item in cardList" :key="item.id">
            <van-image :src="$oss(item.cover)"></van-image>
            <div class="text-center text-12 text-grey margin-top-4">{{ item.name }}</div>
          </div>
        </div>
      </div>

      <div class="bg-white padding-tb-20 padding-lr-14 margin-top-8">
        <div class="driver-title-tip">请保证</div>
        <div class="margin-top-20">
          <p
            v-for="(item, index) in promiseList"
            :key="item"
            class="text-12"
            :class="[index === promiseList.length - 1 ? 'text-black text-bold' : 'text-grey']"
          >{{ item }}</p>
        </div>

        <div class="margin-tb-20 text-center text-12 text-yellow">平台将依据法律规定及相关约定保护你的信息安全</div>
      </div>
    </div>

    <div class="page-footer">
      <van-button type="primary" block @click="onRegister">认证成为顺风车车主</van-button>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      joinList: [
        {
          id: 1,
          name: '海量订单',
          icon: 6
        },
        {
          id: 2,
          name: '安全保障',
          icon: 7
        }
      ],
      cardList: [
        {
          id: 1,
          name: '身份证',
          cover: 1
        },
        {
          id: 2,
          name: '驾驶证',
          cover: 2
        },
        {
          id: 3,
          name: '行驶证',
          cover: 3
        },
        {
          id: 5,
          name: '爱车',
          cover: 5
        }
      ],
      promiseList: [
        '驾驶证：驾龄满1年，准驾车型在C2及以上',
        '行驶证：车龄不超过15年，非营运性质小型汽车',
        '年龄要求：20-65岁',
        '请在1小时内完成资料提交',
        '请在光线充足的场景进行认证',
        '伪造证件属于违法犯罪行为，一经发现，将向有关部门举报，国家机关可依法追究刑事责任。'
      ]
    }
  },
  methods: {
    onRegister () {
      window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.dy.easy.trip'
    }
  }
}
</script>

<style lang="scss" scoped>
.driver-container {
  padding-bottom: 70px;
  .header-info {
    position: absolute;
    width: 100%;
    left: 0;
    bottom: 24%;

    .header-info-title {
      position: relative;
      padding: 0 2px;
      z-index: 1;
      &::after {
        content: "";
        display: block;
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        height: 12px;
        background-color: $primary;
        z-index: -1;
      }
    }
  }

  .join-us {
    position: relative;
    z-index: 1;
    margin-top: -6%;
    .join-us-content {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 14px;
      & > div {
        background-color: rgba($color: $primary, $alpha: 0.05);
        .icon {
          position: absolute;
          right: 0;
          bottom: 0;
        }
      }
    }
  }
}

.driver-title-tip {
  position: relative;
  font-size: 16px;
  font-weight: bold;
  padding-left: 12px;
  &::before {
    content: "";
    display: block;
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 3px;
    height: 80%;
    background-color: $primary;
  }
}

.card-content {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 14px;
  padding: 14px;
  box-shadow: 0 0 6px 0px #eee;
}

.page-footer {
  position: fixed;
  left: 0;
  bottom: 0;
  right: 0;
  padding: 20px 14px;
  background-color: #fff;
  box-shadow: 0 0 12px 0 #ccc;
}
</style>
